export class MenuTree {
	hijos: MenuTree[];
	filename: string;
	ruta_url: any;
}
